import ProvisioningFormContainer from './ProvisioningFormContainer';

export default ProvisioningFormContainer;
